import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminMultimediaContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeEdited!: boolean;

  @jsonMember(Boolean)
  public readonly canBeDeleted!: boolean;
}
